import { Container } from "components";
import React from "react";
import { Link } from "react-router-dom";

export const Faq = () => {
  return (
    <Container>
      <div className="content-wraper">
        <div class="container-xxl flex-grow-1 container-p-y ">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="#">Help</Link>
              </li>
              <li class="breadcrumb-item active">FAQ</li>
            </ol>
          </nav>
          {/* <section className="network "> */}
            {/* <div className="container network-block"> */}
              <div className="row">
                <div className="col-md-12 mb-5">
                  <div className="network-content">
                    <h5 class="card-header mb-4">FAQ</h5>
                   
                    <div id="accordionPayment" class="accordion text-start">
                      <div class="card accordion-item active">
                        <h2 class="accordion-header">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            aria-expanded="true"
                            data-bs-target="#accordionPayment-1"
                            aria-controls="accordionPayment-1"
                          >
                            What is a Zenosure Membership Card, and how does it
                            work?
                          </button>
                        </h2>

                        <div
                          id="accordionPayment-1"
                          class="accordion-collapse collapse show"
                        >
                          <div class="accordion-body">
                            Zenosure health card is a membership card that, when
                            topped up with a Zenosure Subscription Plan,
                            provides you with discounts when you purchase
                            products or services from our Affiliated Partners.
                            When you present your card to a participating
                            Affiliated Partner, you receive a discount on your
                            bill.
                          </div>
                        </div>
                      </div>

                      <div class="card accordion-item">
                        <h2 class="accordion-header">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#accordionPayment-2"
                            aria-controls="accordionPayment-2"
                          >
                            Who is eligible to get a Zenosure Membership Card
                            and subscribe to the Zenosure Subscription Plan?
                          </button>
                        </h2>
                        <div
                          id="accordionPayment-2"
                          class="accordion-collapse collapse"
                        >
                          <div class="accordion-body">
                            Health cards are typically available to individuals,
                            families, and organisations. A person has to adhere
                            with the following: Person must be 18 or above
                            Person must fill out the Membership Application and
                            pay the due fees in entirety
                          </div>
                        </div>
                      </div>

                      <div class="card accordion-item">
                        <h2 class="accordion-header">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#accordionPayment-3"
                            aria-controls="accordionPayment-3"
                          >
                            How do I use my Zenosure Membership Card with an
                            Affiliated Partner?
                          </button>
                        </h2>
                        <div
                          id="accordionPayment-3"
                          class="accordion-collapse collapse"
                        >
                          <div class="accordion-body">
                            When you visit a healthcare provider, present your
                            health card during the registration process. The
                            facility will then apply the relevant discounts to
                            your bill, and you will be responsible for paying
                            the remaining amount.
                          </div>
                        </div>
                      </div>

                      <div class="card accordion-item">
                        <h2 class="accordion-header">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#accordionPayment-4"
                            aria-controls="accordionPayment-4"
                          >
                            What services are covered by the health card?
                          </button>
                        </h2>
                        <div
                          id="accordionPayment-4"
                          class="accordion-collapse collapse"
                        >
                          <div class="accordion-body">
                            Health cards typically cover a range of medical
                            services, including hospitalisation, outpatient
                            procedures, consultations, diagnostic tests, and
                            more. The specific coverage details are outlined in
                            your health card plan, so be sure to review the
                            terms and conditions.
                          </div>
                        </div>
                      </div>

                      <div class="card accordion-item">
                        <h2 class="accordion-header">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#accordionPayment-5"
                            aria-controls="accordionPayment-5"
                          >
                            Can I use my health card at any hospital or clinic?
                          </button>
                        </h2>
                        <div
                          id="accordionPayment-5"
                          class="accordion-collapse collapse"
                        >
                          <div class="accordion-body">
                            Zenosure provides its members with a network of
                            participating healthcare providers, which is updated
                            every quarter of the year. To maximise your
                            benefits, it's advisable to use the card at
                            in-network facilities.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            {/* </div> */}
          {/* </section> */}
        </div>
      </div>
    </Container>
  );
};
